<template>
  <div :class="{ 'border-alert-error border-2 p-3 px-4 pb-5 rounded-lg text-sm mb-2': submitted && errors.length }">
    <slot />
  </div>
</template>
<script>
export default {
  props: {
    submitted: {
      type: Boolean,
      default: false
    },
    errors: {
      type: [Array, Object, Boolean],
      default() {
        return [];
      }
    }
  }
}
</script>